var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};



//////////////////
// WEBPACK FOOTER
// /Users/abuldauskas/nonwork/walt/packages/walt-compiler/node_modules/babel-runtime/node_modules/core-js/library/modules/_uid.js
// module id = 473
// module chunks = 0